function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import { createPortal } from 'react-dom';
import ToastContext from './toast_context';
import ToastContainer from './toast_container';
import ToastNotification from '../toast_notification';
import { toastProviderPropTypes } from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ToastProvider = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    children,
    domRoot,
    newOnTop = true,
    position = 'bottom'
  } = _ref;
  var [toasts, setToasts] = React.useState([]);
  var addToast = React.useCallback(toast => {
    setToasts(prevToasts => {
      if (prevToasts.find(t => t.id === toast.id)) {
        return prevToasts;
      }
      return [...prevToasts, toast];
    });
  }, []);
  var removeToast = React.useCallback(id => {
    if (typeof id === 'undefined') {
      setToasts([]);
    } else {
      setToasts(prevToasts => prevToasts.filter(t => t.id !== id));
    }
  }, []);
  var updateToast = React.useCallback((id, options) => {
    setToasts(oldToasts => {
      var index = oldToasts.findIndex(t => t.id === id);
      if (index < 0) {
        return oldToasts;
      }
      var updatedToast = _objectSpread(_objectSpread({}, oldToasts[index]), options);
      return [...oldToasts.slice(0, index), updatedToast, ...oldToasts.slice(index + 1)];
    });
  }, []);
  var renderedToasts = ___EmotionJSX(ToastContainer, {
    newOnTop: newOnTop,
    position: position,
    ref: ref
  }, toasts.map(toast => ___EmotionJSX(ToastNotification, _extends({
    key: toast.id,
    onClose: removeToast
  }, toast))));
  return ___EmotionJSX(ToastContext.Provider, {
    value: {
      addToast,
      removeToast,
      updateToast,
      toasts
    }
  }, children, domRoot ? /*#__PURE__*/createPortal(renderedToasts, domRoot) : renderedToasts);
});
ToastProvider.propTypes = toastProviderPropTypes;
ToastProvider.displayName = 'ToastProvider';
export default ToastProvider;